import { For, Show } from 'solid-js'
import { css } from 'styled-system/css'

const mark = css({
  bg: 'color-mix(in srgb, var(--colors-jade-9) 28%, transparent)',
  color: 'inherit',
  borderRadius: '2px',
  px: '1px',
})

const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

/** Renders `text` with every case-insensitive occurrence of `query` wrapped in <mark>. */
export function Highlight(props: { text?: string | null; query: string }) {
  const parts = () => {
    const text = props.text ?? ''
    const q = props.query.trim()
    if (!q) return [text]
    return text.split(new RegExp(`(${escapeRegExp(q)})`, 'gi'))
  }

  return (
    <For each={parts()}>
      {(part, i) => (
        <Show when={i() % 2 === 1} fallback={part}>
          <mark class={mark}>{part}</mark>
        </Show>
      )}
    </For>
  )
}
